module.exports = __webpack_public_path__ + "static/img/editor-type1.b65b6dd9.png";